import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatCounter } from '../../utils/formatCounter';
import config from '../../config';

const SWIPE_THRESHOLD = 60;

export const ChatCard = ({ id, userId, img, name, age, lMsg, time, count, link_to_full_chat, onDelete }) => {
  const navigate = useNavigate();

  const [isSwiped, setIsSwiped] = useState(false);

  const startX = useRef(0);
  const startY = useRef(0);
  const currentX = useRef(0);
  const isHorizontalSwipe = useRef(false);

  const handleTouchStart = (e) => {
    const touch = e.touches[0];

    startX.current = touch.clientX;
    startY.current = touch.clientY;
    currentX.current = touch.clientX;
    isHorizontalSwipe.current = false;
  };

  const handleTouchMove = (e) => {
    const touch = e.touches[0];

    currentX.current = touch.clientX;

    const diffX = startX.current - currentX.current;
    const diffY = Math.abs(startY.current - touch.clientY);

    // Определяем, горизонтальный ли это свайп
    if (!isHorizontalSwipe.current) {
      if (Math.abs(diffX) < 10) {
        return;
      }

      // Если движение больше вертикально —
      // это обычный скролл списка
      if (diffY > Math.abs(diffX)) {
        return;
      }

      isHorizontalSwipe.current = true;
    }

    // Свайп вправо — закрываем
    if (diffX < -30) {
      setIsSwiped(false);
      return;
    }

    // Свайп влево — открываем только после 60px
    if (diffX >= SWIPE_THRESHOLD) {
      setIsSwiped(true);
    }
  };

  const handleTouchEnd = () => {
    startX.current = 0;
    startY.current = 0;
    currentX.current = 0;
    isHorizontalSwipe.current = false;
  };

  const handleMoveBack = () => {
    setIsSwiped(false);
  };

  const handleCardClick = () => {
    if (isSwiped) {
      setIsSwiped(false);
      return;
    }

    navigate(link_to_full_chat);
  };

  const isGift = lMsg && typeof lMsg === 'object' && lMsg.type === 'gift';

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className={`
          relative z-1 w-full
          flex items-center justify-center
          transition-transform duration-300
          ${isSwiped ? '-translate-x-20' : 'translate-x-0'}
        `}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={handleCardClick}
      >
        <div className="text-white w-full p-4 flex flex-row h-[84px] items-center font-raleway">
          <img
            src={img}
            alt="Аватар пользователя"
            className="w-[48px] h-[48px] rounded-[50%] mr-[16px] shrink-0 object-cover"
            onClick={(e) => {
              e.stopPropagation();
              navigate(config.ROUTES.CHATS.PROFILE(userId));
            }}
          />

          <div className="flex flex-col justify-start flex-1 min-w-0 h-full gap-1">
            <p className="text-[16px] font-semibold leading-[24px]">
              {name}, {age}
            </p>

            {isGift ? (
              <img src={lMsg.gift.image} alt="Подарок" className="w-[28px] h-[28px] mr-[16px] shrink-0 object-cover" />
            ) : lMsg && typeof lMsg === 'object' && lMsg.type === 'event' ? (
              <p className="text-[14px] font-normal truncate min-w-0 text-[#A1F69E]">
                Приглашение на мероприятие
              </p>
            ) : (
              <p className="text-[14px] font-normal truncate min-w-0">
                {typeof lMsg === 'string' ? lMsg : lMsg?.text || ''}
              </p>
            )}
          </div>

          <div className="flex flex-col justify-center items-end">
            <p className="text-[14px] font-normal opacity-70 text-white text-right">{time}</p>

            {count > 0 && (
              <div className="rounded-[50%] text-[14px] bg-[#A1F69E] min-w-[24px] h-[24px] flex items-center justify-center text-black">
                {formatCounter(count)}
              </div>
            )}
          </div>
        </div>
      </div>

      {isSwiped && (
        <img
          src="/icons/delete_chat.svg"
          alt="Удалить чат"
          onClick={(e) => {
            e.stopPropagation();
            handleMoveBack();
            onDelete(id);
          }}
          className="w-[84px] h-[84px] absolute top-0 right-0 z-0"
        />
      )}
    </div>
  );
};
